import type { ButtonHTMLAttributes, ReactNode } from "react";
import { useEffect } from "react";

export function Button({
  children,
  variant = "default",
  className = "",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "primary" | "ghost";
  children: ReactNode;
}) {
  const styles =
    variant === "primary" ? "clay-accent" : variant === "ghost" ? "bg-transparent shadow-none" : "";
  return (
    <button
      {...props}
      className={`clay-btn px-5 py-3 text-base font-extrabold disabled:opacity-40 ${styles} ${className}`}
    >
      {children}
    </button>
  );
}

export function Screen({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div className={`mx-auto flex min-h-full w-full max-w-[30rem] flex-col px-4 pad-safe ${className}`}>
      {children}
    </div>
  );
}

export function Toast({ message, onDone }: { message: string | null; onDone: () => void }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(onDone, 2400);
    return () => clearTimeout(t);
  }, [message, onDone]);
  if (!message) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-50 flex justify-center px-4">
      <div className="clay animate-pop max-w-[90%] px-4 py-2 text-sm font-bold">{message}</div>
    </div>
  );
}
